'use client';

import React from 'react';
import { FullListing } from '@th/shared/src/types/FullListing';
import { useUser } from '../../contexts/UserContext';
import { useAuthModal } from '../../contexts/AuthModalContext';
import Button from '../Button';
import blurText from '../../helpers/blurText';
import { OFFER_TOOLTIP_TEXT } from '@th/frontend-shared/src/constants/tooltip';
import SvgIcon from '../icons/SvgIcon';
import Tooltip from '../Tooltip';

type Props = {
  listing: FullListing;
  bottomDivider: any;
};

export default function ListingOfferDetails({ listing, bottomDivider }: Props) {
  const { isLoggedIn } = useUser();

  if (listing.isSold() && listing.hadAtLeastOneOffer()) {
    return (
      <div>
        <h3 className="mb-4">Offer Details</h3>
        <p>
          <span className="mr-2">Sold with</span>
          <span className={!isLoggedIn ? 'blur-sm' : ''}>
            {blurText(
              `${listing.offerCount.toString()}${!isLoggedIn ? 'xx' : ''}`,
              !isLoggedIn,
            )}
          </span>
          <span className="ml-2">
            offer{isLoggedIn ? (listing.offerCount === 1 ? '' : 's') : 's'}
          </span>
          {!isLoggedIn && <SignInButton title={'Sign in to see offer count'} />}
        </p>
        {bottomDivider}
      </div>
    );
  }

  if (listing.shouldDisplayOfferDate()) {
    return (
      <div>
        <div className="flex flex-row items-baseline">
          <h3 className="mb-4">Offer Details</h3>
          <SvgIcon
            name="TbInfoCircle"
            className="ml-2 h-4 w-4 mb-0 text-primary hover:cursor-pointer"
            data-tooltip-id="offer-details-tooltip"
            data-tooltip-content={OFFER_TOOLTIP_TEXT}
          />
        </div>
        <p>
          <span className="mr-4">Offer date:</span>
          <span className={!isLoggedIn ? 'blur-sm' : ''}>
            {blurText(listing.offerDateText(), !isLoggedIn)}
          </span>
          {!isLoggedIn && <SignInButton title={'Sign in to see offer date'} />}
        </p>
        <Tooltip id="offer-details-tooltip" />
        {bottomDivider}
      </div>
    );
  }

  return null;
}

function SignInButton({ title }) {
  const { openAuthModal } = useAuthModal();

  return (
    <Button
      buttonClassName={`block md:inline md:ml-8 mt-4 md:mt-0`}
      onClick={() => {
        openAuthModal();
      }}
      title={title}
    />
  );
}
